// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1wLVP","label":"Category_label__1nySK","content":"Category_content__3OYTf","header":"Category_header__2e-lY","location":"Category_location__3Ytrb"};